(ns renolit-roofing-service.util
  (:require [ajax.core :as ajax]
            [clojure.string :as str]
            [fipp.edn :as fipp]
            [re-frame.core :as rf]
            [renolit-roofing-service.shared.util.transit :as util.transit]
            [renolit-roofing-service.tooltip.loading-popup :as loading-popup]))

(defn ajax-transit-response-format
  []
  (ajax/transit-response-format
   {:handlers
    util.transit/custom-read-handlers}))

(defn ajax-transit-request-format
  []
  (ajax/transit-request-format
   {:handlers
    util.transit/custom-write-handlers}))

(defn- build-callback-evts
  [evts result]
  (if (every? vector? evts)
    (mapv #(vector :dispatch (conj % result)) evts)
    [[:dispatch (conj evts result)]]))

(defn execute-callback
  [action & args]
  (when-let [callback-fn (:fn action)]
    (apply callback-fn args))
  (when-let [callback-evt (:evt action)]
    (rf/dispatch (vec (concat callback-evt args))))
  (when-let [callback-evts (:evts action)]
    (doseq [callback-evt callback-evts]
      (rf/dispatch (vec (concat callback-evt args))))))

(defn normalize-str-for-search
  [s]
  (-> (str s)
      (str/trim)
      (str/lower-case)))

(defn- search-match?
  [search-string search-keys m]
  (if (empty? search-string)
    true
    (some
     (fn [[_ v]]
       (str/includes? (normalize-str-for-search v) search-string))
     (select-keys m search-keys))))

(defn filter-search-coll
  [search-string search-keys coll]
  (let [search-string (normalize-str-for-search search-string)]
    (filter (partial search-match? search-string search-keys) coll)))

(defn absolute-url?
  [url-str]
  (re-matches #"^https?://.+$" url-str))

(defn serialize-sort-by-params
  "Serialization of sorting params as string for API requests

  We need to deal with possible namespaced keywords transformed
  to strings.

  We keep using a `;` symbol to separate the `sort-prop`
  from the `sort-suffix`."
  [sort-by-params]
  (->> sort-by-params
       (map (fn [[sort-prop sort-suffix]]
              (let [sort-prop-prefix-ns (namespace sort-prop)
                    sort-prop-name (name sort-prop)
                    final-sort-prop (if sort-prop-prefix-ns
                                      (str sort-prop-prefix-ns "/" sort-prop-name)
                                      sort-prop-name)]
                (str/join ";" [final-sort-prop (name sort-suffix)]))))))

(def ^:private js-log (js* "console.log"))

(def ^:private name* (fnil name ""))

(defn clog
  "Use it when you want to always emmit a message to
  console. Pass a map with options :color :font :background-color
  after whatever the arguments to be printed are. Pass delay for
  delayed execution. The options can
  also be symbols or srings aside of keywords. pass {ugly: true}
  to disable pretty printing "
  [& args]
  (if (some-> args last map?)
    (let [butlast-args (butlast args)
          {:keys [color background-color font-weight font-size json ugly delay]} (last args)
          with-styling-options? (or color background-color font-weight font-size json ugly)
          delayed (if (int? delay) (fn [op] (js/setTimeout op delay)) (fn [op] (op)))]
      (delayed
       (fn []
         (if with-styling-options?
           (let [css-options (str "color:" (name* color) \;
                                  "background-color:" (name* background-color) \;
                                  "font-weight:" (name* font-weight) \;
                                  "font-size:" (name* font-size))]
             (js-log (apply str \% \c
                            (cond (not ugly) (mapv
                                              (fn [x] (with-out-str (fipp/pprint x)))
                                              butlast-args)
                                  :else butlast-args))
                     css-options))
           (println (with-out-str (apply fipp/pprint args)))))))
    (apply fipp/pprint args)))

(defn dlog
  "Like clog bellow but google compiler will remove whith advance
   optimizations. Excellent for development"
  [& more]
  (when goog.DEBUG
    (try
      (apply clog more)
      (catch js/Object exp (print exp)))))

(defn filter-map
  [m pred]
  (select-keys m (for [[k v] m :when (pred [k v])] k)))
;; Here we make dlog a global js object, so we can access it from everywhere without namespace decleration :)

(js* "var dlog;")

(set! js/dlog dlog)

(rf/reg-event-fx
 ::generic-success
 (fn [{:keys [db]} _]
   {:dispatch [::loading-popup/stop-loading]
    :db db}))

(rf/reg-event-fx
 ::generic-success-with-callback
 (fn [{:keys [db]} [_ on-success-evt result]]
   {:fx (cond-> [[:dispatch [::generic-success]]]

          on-success-evt
          (into (build-callback-evts on-success-evt result)))
    :db db}))

(rf/reg-event-fx
 ::generic-error
 (fn [{:keys [db]} [_ e]]
   {:dispatch [::loading-popup/stop-loading]
    :db (update db :errors-log (fnil conj []) e)}))

(rf/reg-event-fx
 ::generic-error-with-callback
 (fn [_ [_ on-failure-evt opts result]]
   {:fx (cond-> [[:dispatch [::generic-error opts result]]]
          on-failure-evt
          (into (build-callback-evts on-failure-evt result)))}))

(defn number->locale-string
  [number {:keys [locale style currency unit min-fraction-digits max-fraction-digits]
           :or {locale "es-ES"
                style "decimal"
                min-fraction-digits 0
                max-fraction-digits 2}}]
  (let [number (cond-> number
                 (= style "percent")
                 (/ 100))
        opts (clj->js
              (cond-> {:minimumFractionDigits min-fraction-digits
                       :maximumFractionDigits max-fraction-digits
                       :style style}
                (and (= style "currency") currency)
                (assoc :currency currency)

                (and (= style "currency") (not currency))
                (dissoc :style)

                (= style "unit")
                (assoc :unit (name unit))))]
    (.toLocaleString number locale opts)))

(defn json->clj
  [json-str]
  (js->clj (.parse js/JSON json-str) :keywordize-keys true))
